var _g, _g2, _rect, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _path7, _rect3, _g3, _rect4, _path8, _path9, _path10, _rect5, _circle6, _circle7, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse2, _path18, _circle8, _path19, _path20, _path21, _rect6, _rect7, _rect8, _rect9, _rect10, _path22, _path23, _path24, _circle9, _path25, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeroIllustration = function SvgHeroIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1068,
    height: 426,
    viewBox: "0 0 1068 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 330,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 342,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 354,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 366,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 378,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 390,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 402,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 162,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 174,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 186,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 198,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 210,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 222,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 234,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 246,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 258,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 270,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 282,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 294,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 306,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 318,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624,
    cy: 318,
    r: 2,
    fill: "#044289"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 285,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 297,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 309,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 321,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 333,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 345,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 357,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 964,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 117,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 129,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 141,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 153,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 165,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 177,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 189,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 201,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 213,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 225,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 237,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 249,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 261,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1012,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1036,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 988,
    cy: 273,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 273,
    r: 2,
    fill: "#044289"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 782.5,
    y: 79.5,
    width: 255,
    height: 255,
    fill: "#22272e",
    stroke: "#79B8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M910 334V80",
    stroke: "#044289"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M783 203H1037",
    stroke: "#044289"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M782 309.4H1038",
    stroke: "#79B8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M782 104.6H1038",
    stroke: "#79B8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M807.6 335V79",
    stroke: "#79B8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.4 335V79",
    stroke: "#79B8FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 512,
    cy: 239.287,
    rx: 47,
    ry: 46,
    fill: "#22272e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 406.5,
    y: 125.5,
    width: 255,
    height: 255,
    fill: "#22272e",
    stroke: "#79B8FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 429.04,
    cy: 360.96,
    r: 12.8,
    fill: "#0366D6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.2,
    cy: 360.96,
    r: 12.8,
    fill: "#005CC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 485.36,
    cy: 360.96,
    r: 12.8,
    fill: "#044289"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 513.52,
    cy: 360.96,
    r: 12.8,
    fill: "#032F62"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 541.68,
    cy: 360.96,
    r: 12.8,
    fill: "#05264C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M406 342.92H662",
    stroke: "#79B8FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14.2566,
    height: 14.2566,
    transform: "matrix(-0.70678 -0.707433 -0.706576 0.707638 446.15 149.086)",
    stroke: "#2188FF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 219,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 231,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 243,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 255,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 267,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 279,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 291,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 51,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 63,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 75,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 87,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 99,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 111,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 123,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 135,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 147,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 159,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 171,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 183,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 195,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 207,
    r: 2,
    fill: "#044289"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 207,
    r: 2,
    fill: "#044289"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 72.5,
    width: 255,
    height: 255,
    fill: "#22272e",
    stroke: "#79B8FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M254 129L248 139.392H236L230 129L236 118.608H248L254 129Z",
    stroke: "#2188FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.481 247.716H137.066L98.8281 144H86.0344L47.7969 247.716H61.3813L71.8031 218.031H113.059L123.481 247.716ZM92.2156 159.741H92.6469L109.25 207.034H75.6125L92.2156 159.741Z",
    fill: "#005CC5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.021 238.372C163.036 238.372 157.071 233.7 157.071 226.584C157.071 219.541 162.821 215.084 172.883 214.438L192.865 213.216V219.325C192.865 230.106 183.808 238.372 172.021 238.372ZM169.218 249.009C179.28 249.009 188.768 243.403 193.224 234.85H193.511V247.716H205.371V196.038C205.371 181.159 194.302 171.672 176.765 171.672C159.083 171.672 148.015 181.591 147.152 194.528H159.227C160.808 187.197 166.846 182.669 176.477 182.669C186.827 182.669 192.865 188.131 192.865 197.259V203.513L171.446 204.734C154.196 205.741 144.349 213.791 144.349 226.584C144.349 240.025 154.34 249.009 169.218 249.009Z",
    fill: "#005CC5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 253.849,
    width: 161,
    height: 3.06667,
    fill: "#005CC5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 302,
    r: 9,
    stroke: "#C8E1FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 56,
    r: 18,
    fill: "#22272e",
    stroke: "#C8E1FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M542.429 34L531 34L536.714 24L542.429 34Z",
    stroke: "#2188FF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.939 54.765H565.361L569.547 45L557 57.5475H562.578L558.391 67.3125L570.939 54.765Z",
    fill: "#79B8FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M958 284V266L974.5 261.5L989.5 266V284L974.5 288.5L958 284Z",
    fill: "#22272e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M957.25 266.607V283.415C957.25 284.427 957.925 285.305 958.938 285.597L973.562 289.49C973.923 289.602 974.327 289.602 974.688 289.49L989.312 285.597C990.325 285.305 991 284.427 991 283.415V266.607C991 265.595 990.325 264.717 989.312 264.425L974.688 260.51C974.327 260.442 973.923 260.442 973.562 260.51L958.938 264.425C957.925 264.717 957.25 265.595 957.25 266.607ZM973 287.06L959.5 283.482V268.25L973 271.872V287.06ZM959.5 266L965.125 264.492L979.75 268.385L974.125 269.892L959.5 266ZM988.75 283.482L975.25 287.06V271.872L979.75 270.635V276.125L984.25 274.932V269.442L988.75 268.25V283.482ZM984.25 267.192L969.625 263.3L974.125 262.107L988.75 266L984.25 267.192Z",
    fill: "#79B8FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132 90H147.529L154 96.2651V116H132V90Z",
    fill: "#22272e"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148 88H133C131.9 88 131 88.9 131 90V114C131 115.1 131.9 116 133 116H153C154.1 116 155 115.1 155 114V95L148 88ZM153 114H133V90H147L153 96V114ZM141 99.96L138 103L141 106L140 108L135 103L140 98L141 99.96ZM146 98L151 103L146 108L145 106.04L148 103L145 100L146 98Z",
    fill: "#79B8FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M970.5 265C931.5 208.44 880 327.5 836 289C784.211 243.685 904.458 40.5001 772 40.5001C635.5 40.5001 490.33 332.889 332 386C253 412.5 177.721 341.596 237 250C296.279 158.404 421.42 99.5001 389.5 46.5C365.402 6.48898 206.057 48.2102 150 92.4167",
    stroke: "#C8E1FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 533.923,
    cy: 231,
    rx: 60.9231,
    ry: 60,
    fill: "#22272e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.988 171.08C500.749 171.08 473.84 198.096 473.84 231.44C473.84 258.156 491.058 280.717 514.964 288.714C517.967 289.242 519.104 287.429 519.104 285.844C519.104 284.415 519.032 279.66 519.032 274.605C503.92 277.403 500.007 270.907 498.811 267.509C498.129 265.768 495.197 260.413 492.649 258.984C490.543 257.855 487.54 255.058 492.577 254.986C497.315 254.914 500.701 259.356 501.826 261.169C507.234 270.295 515.885 267.737 519.343 266.152C519.869 262.226 521.449 259.584 523.172 258.084C509.783 256.571 495.808 251.372 495.808 228.282C495.808 221.714 498.141 216.287 501.97 212.06C501.371 210.547 499.266 204.364 502.568 196.067C502.568 196.067 507.605 194.482 519.116 202.25C523.925 200.894 529.046 200.209 534.156 200.209C539.265 200.209 544.386 200.894 549.195 202.25C560.694 194.398 565.743 196.067 565.743 196.067C569.057 204.364 566.952 210.559 566.341 212.06C570.17 216.287 572.503 221.642 572.503 228.282C572.503 251.444 558.444 256.583 545.056 258.084C547.233 259.969 549.112 263.595 549.112 269.25C549.112 277.319 549.04 283.815 549.04 285.856C549.04 287.441 550.165 289.326 553.18 288.726C576.942 280.729 594.16 258.096 594.16 231.452C594.136 198.096 567.215 171.08 533.988 171.08Z",
    fill: "#2188FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 43,
    r: 10,
    fill: "#22272e"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M805.505 41.59L803.885 39.58C803.63 39.25 803.465 38.86 803.42 38.425L803.135 35.875C803.015 34.825 802.19 34 801.14 33.88L798.59 33.595C798.14 33.55 797.75 33.355 797.42 33.1L795.41 31.48C794.585 30.82 793.415 30.82 792.59 31.48L790.58 33.1C790.25 33.355 789.86 33.52 789.425 33.565L786.875 33.85C785.825 33.97 785 34.795 784.88 35.845L784.595 38.395C784.55 38.845 784.355 39.235 784.1 39.565L782.48 41.575C781.82 42.4 781.82 43.57 782.48 44.395L784.1 46.405C784.355 46.735 784.52 47.125 784.565 47.56L784.85 50.11C784.97 51.16 785.795 51.985 786.845 52.105L789.395 52.39C789.845 52.435 790.235 52.63 790.565 52.885L792.575 54.505C793.4 55.165 794.57 55.165 795.395 54.505L797.405 52.885C797.735 52.63 798.125 52.465 798.56 52.42L801.11 52.135C802.16 52.015 802.985 51.19 803.105 50.14L803.39 47.59C803.435 47.14 803.63 46.75 803.885 46.42L805.505 44.41C806.165 43.585 806.165 42.415 805.505 41.59ZM791.75 49L786.5 43.75L788.75 41.5L791.75 44.5L799.25 37L801.5 39.325L791.75 49Z",
    fill: "#79B8FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M641 280C641 284.8 632 284.8 632 289.6C632 294.4 641 294.4 641 299.2C641 304 632 304 632 308.8C632 313.6 641 313.6 641 318.4C641 323.2 632 323.2 632 328",
    stroke: "#C8E1FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M138 287C142 287 142 295 146 295C150 295 150 287 154 287C158 287 158 295 162 295C166 295 166 287 170 287C174 287 174 295 178 295",
    stroke: "#2188FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 729,
    y: 131,
    width: 37.0656,
    height: 36,
    fill: "#005CC5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 790.776,
    y: 131,
    width: 98.2239,
    height: 36,
    fill: "#005CC5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 845,
    y: 213,
    width: 91,
    height: 24,
    fill: "#044289"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 213,
    width: 30,
    height: 24,
    fill: "#044289"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 283.5,
    y: 382.5,
    width: 19.5,
    height: 21,
    fill: "#22272e"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297 399H301.5V384H297V399ZM291 396H295.5V384H291V396ZM285 402H289.5V384H285V402ZM283.5 403.5H303V382.5H283.5V403.5ZM303 381H283.5C282.672 381 282 381.672 282 382.5V403.5C282 404.328 282.672 405 283.5 405H303C303.828 405 304.5 404.328 304.5 403.5V382.5C304.5 381.672 303.828 381 303 381Z",
    fill: "#79B8FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M954 131C958 131 958 123 962 123C966 123 966 131 970 131C974 131 974 123 978 123C982 123 982 131 986 131C990 131 990 123 994 123",
    stroke: "#C8E1FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M756.762 374.398L746.37 392.419L735.996 374.409L756.762 374.398Z",
    stroke: "#C8E1FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 974,
    cy: 46,
    r: 6,
    stroke: "#2188FF",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M105.706 371.932L98.7897 383.939L91.8737 371.932L105.706 371.932Z",
    stroke: "#2188FF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 248,
    fill: "white",
    transform: "translate(378 156)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 248,
    fill: "white",
    transform: "translate(814 111)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 248,
    fill: "white",
    transform: "translate(2 45)"
  })))));
};
export { SvgHeroIllustration as ReactComponent };
export default __webpack_public_path__ + "static/hero-illustration.e96a602b.svg";